var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84435 12.8376C5.63089 12.8376 4.46714 12.3556 3.6091 11.4975C2.75106 10.6395 2.26902 9.47572 2.26902 8.26227C2.26902 7.04881 2.75106 5.88506 3.6091 5.02702C4.46714 4.16898 5.63089 3.68694 6.84435 3.68694C8.05793 3.68694 9.22181 4.16903 10.0799 5.02716C10.9381 5.8853 11.4202 7.04918 11.4202 8.26276C11.4202 9.47634 10.9381 10.6402 10.0799 11.4984C9.22181 12.3565 8.05793 12.8386 6.84435 12.8386V12.8376ZM11.4403 4.59494L12.3679 3.66635C12.0737 3.33295 11.7795 3.0329 11.4461 2.74461L10.5185 3.68596C9.48158 2.83889 8.1833 2.37702 6.84435 2.37886C5.28397 2.37886 3.7875 2.99872 2.68415 4.10207C1.58079 5.20542 0.960938 6.70189 0.960938 8.26227C0.960938 9.82264 1.58079 11.3191 2.68415 12.4225C3.7875 13.5258 5.28397 14.1457 6.84435 14.1457C10.1126 14.1457 12.7278 11.5109 12.7278 8.26227C12.7284 6.92894 12.2742 5.63527 11.4403 4.59494ZM6.19031 8.91631H7.49838V4.99403H6.19031M8.80548 0.417725H4.88321V1.72482H8.80548V0.417725Z",
    fill: "#535969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchB);
export default __webpack_public_path__ + "static/media/watchB.53be5e6d50ddffb8b97e9c8a79cd1881.svg";
export { ForwardRef as ReactComponent };